



















































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import PhotoHeader from '../components/organization/PhotoHeader.vue'
import Main from '../components/organization/Main.vue'
import MiniCourse from '../components/artigos/index.vue'
import { Anais, Anais2, Anais3, livros } from '@/storage/programacao/anais'
import { Palestras_Cursos } from '@/storage/programacao/artigos_aprovados'

@Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse
  }
})
export default class IntegratedComponent extends Vue {
  private all_anais: any
  private all_anais2: any
  private all_anais3: any
  private all_livros: any
  private all_palestras: any
  private filtered_palestras: any

  private title = 'Anais'
  private description = 'Publicações e Palestras da JCPOLI'
  private background = 'assets/img/slider/6.jpg'

  filterPalestras(e) {
    let data = e.target.innerText
    this.filtered_palestras = this.all_palestras.map(item => {
      let palestras = item.palestras.filter(aux => {
        return aux.date == data
      })
      return { ...item, palestras }
    })
  }

  clearFilter() {
    this.filtered_palestras = this.all_palestras
  }

  constructor() {
    super()

    this.all_anais = Anais
    this.all_anais2 = Anais2
    this.all_anais3 = Anais3
    this.all_livros = livros
    this.all_palestras = Palestras_Cursos
    this.filtered_palestras = this.all_palestras
  }
}
